export default __webpack_public_path__ + "static/FbTestimonial5-e010cb0ba82bc7702c1dd334541b2f30.jpeg";